const stickyFilters = () => {
	const $placeholder = document.querySelector(".pt-mobile-header--placeholder");
	const $filters = document.querySelector(".pt-mobile-header");
	const $nav = document.querySelector(".header-wrapper");

	window.addEventListener("scroll", () => {
		if (
			window.scrollY > $placeholder.offsetTop + $filters.offsetHeight &&
			window.innerWidth < 768
		) {
			$filters.classList.add("is-sticky");
			$filters.style.top = $nav.offsetHeight + "px";
		} else {
			$filters.classList.remove("is-sticky");
		}
	});
};

document.addEventListener("DOMContentLoaded", () => {
	// stickyFilters();
});
